import styled from 'styled-components';
import { colors } from 'spw-theme';

export const PSCardGroupHeader = styled.div`
  height: 24px;
  background-color: ${colors.lightGreyBackground} !important;
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  margin-left: -16px;
  display: flex;
  span {
    color: ${colors.black};
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    text-transform: uppercase;
    white-space: nowrap;
  }
`;
